import * as S from './RatingBadge.styles'

interface RatingBadgeProps {
  rating: string | number
}

export const RatingBadge = ({ rating }: RatingBadgeProps) => {
  return (
    <S.Root>
      <S.StarIcon />
      {rating}
    </S.Root>
  )
}
